/* Panning specific styles */
@import '../../../shared/components/common-links/common-links';

.scroll-snap-type {
  scroll-snap-type: x mandatory; /* Safari */
  scroll-snap-destination: 50% 50%;
}

.scroll-snap {
  scroll-snap-align: center; /* older (Firefox/IE) */
  scroll-snap-coordinate: 50% 50%; /* older (Safari) */
  scroll-snap-stop: normal;
}

/* End of: Panning specific styles */

.comparison-container {
  display: flex;
  justify-content: left;
  padding: $space-05 0 0;

  @include agl-ds-screen-size('medium') {
    padding: $space-06 0 0;
  }
}

.card-container {
  display: flex;
  margin-left: 50px;
}

.guided-flow-nbn-heading {
  text-align: center;
  margin-top: $space-07;
}

.card {
  font-family: 'Open Sans', sans-serif;
  box-sizing: border-box;
  width: 284px;
  margin-right: $space-04;
  margin-top: $space-00;

  &:last-child {
    margin-right: 0;
  }

  @include agl-ds-screen-size('medium') {
    width: 384px;
  }

  &__with-space {
    margin-top: $space-06;
  }

  &__spacer {
    width: 100%;
    height: 2px;
  }

  &__wrapper {
    margin-right: $space-04;

    &:last-child {
      margin-right: 0;
    }
  }

  &__plan-selected {
    border: 2px solid #001cb0;
    box-sizing: border-box;
    box-shadow: 0 16px 32px 2px rgb(43 46 49 / 16%);
    border-radius: 4px;
  }
}

.cta {
  &--button {
    margin-bottom: $space-02;

    @include agl-ds-screen-size('medium') {
      margin-bottom: $space-03;
    }
  }

  &--mid {
    padding-bottom: $space-01;
  }

  &--end {
    padding-bottom: $space-03;

    @include agl-ds-screen-size('large') {
      padding-bottom: $space-04;
    }
  }
}

.product-description {
  margin-top: 15px;
  display: block;

  @include agl-ds-screen-size('medium') {
    margin-top: 35px;
  }
}

.links {
  text-align: center;
  line-height: 200%;
}

.responsive-spacer {
  margin-top: 16px;
}

@media (min-width: 425px) {
  .responsive-spacer {
    margin-top: 24px;
  }
}

.feature-list {
  margin: 15px 0 24px;
}

.unavailable-overlay-container {
  position: relative;
}

.unavailable-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255 255 255 / 95%);
  z-index: 5;
}

.product-headline {
  font-size: 14px;
  font-weight: 400;
}

.below-cards-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-bottom: 14px !important;
  }
}

.below-cards-message .sq-message-container {
  font-family: $font-family-02;
  margin: 0 auto;
  max-width: 1280px;
  padding-left: 32px;
  padding-right: 32px;
  text-align: left;

  p {
    line-height: 18px;
    font-size: 12px;
    margin-bottom: 0;

    a {
      font-size: 12px;
    }
  }
}
